import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/Logo';
import { useAuth } from '@/features/auth/auth-context';
import { ADMIN_NAV } from './admin-nav';

export function AdminSidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { t } = useTranslation('admin');
  const { user } = useAuth();
  const { pathname } = useLocation();

  const visible = ADMIN_NAV.filter(
    (item) => !item.roles || (user && item.roles.includes(user.role)),
  );

  return (
    <Stack sx={{ height: '100%' }}>
      <Box sx={{ p: 2.5 }}>
        <Logo compact />
      </Box>
      <Divider />

      <List component="nav" sx={{ py: 1.5, flex: 1 }}>
        {visible.map(({ key, to, Icon }) => {
          const selected = pathname === to || pathname.startsWith(`${to}/`);
          return (
            <ListItemButton
              key={key}
              component={NavLink}
              to={to}
              selected={selected}
              onClick={onNavigate}
              sx={{ mb: 0.25, color: selected ? 'text.primary' : 'text.secondary' }}
            >
              <ListItemIcon sx={{ minWidth: 38, color: 'inherit' }}>
                <Icon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={t(`nav.${key}`)}
                primaryTypographyProps={{ fontSize: 14, fontWeight: selected ? 650 : 500 }}
              />
            </ListItemButton>
          );
        })}
      </List>

      <Divider />
      <Box sx={{ p: 2 }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {user?.name}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {user?.email}
        </Typography>
      </Box>
    </Stack>
  );
}
